"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineObject1ToJSON = exports.InlineObject1FromJSONTyped = exports.InlineObject1FromJSON = void 0;
var runtime_1 = require("../runtime");
function InlineObject1FromJSON(json) {
    return InlineObject1FromJSONTyped(json, false);
}
exports.InlineObject1FromJSON = InlineObject1FromJSON;
function InlineObject1FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'limit': !(0, runtime_1.exists)(json, 'limit') ? undefined : json['limit'],
        'onlyOutdated': !(0, runtime_1.exists)(json, 'onlyOutdated') ? undefined : json['onlyOutdated'],
        'dryRun': !(0, runtime_1.exists)(json, 'dryRun') ? undefined : json['dryRun'],
    };
}
exports.InlineObject1FromJSONTyped = InlineObject1FromJSONTyped;
function InlineObject1ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'limit': value.limit,
        'onlyOutdated': value.onlyOutdated,
        'dryRun': value.dryRun,
    };
}
exports.InlineObject1ToJSON = InlineObject1ToJSON;
